import EllyannaAiAssistant from "../components/ai/EllyannaAiAssistant";

export default function EllyannaAiAssistantPage() {
  return <EllyannaAiAssistant />;
}
